var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIsolationMentalHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00004 4.81394L6.65704 2.46994C6.03202 1.86622 5.19488 1.53215 4.32593 1.53968C3.45699 1.5472 2.62576 1.89574 2.0113 2.5102C1.39684 3.12466 1.0483 3.95589 1.04077 4.82484C1.03324 5.69378 1.36732 6.53092 1.97104 7.15594L4.31404 9.49994M4.31404 9.49994L9.00004 14.1859L16.03 7.15594C16.6336 6.5308 16.9675 5.69358 16.9598 4.82464C16.9521 3.95569 16.6034 3.12454 15.9888 2.5102C15.3742 1.89587 14.5429 1.54752 13.674 1.54017C12.805 1.53283 11.9679 1.86709 11.343 2.47094L4.31404 9.49994Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsolationMentalHealth);
export default __webpack_public_path__ + "static/media/isolation_mental_health.e5e4536d632eeb440496c876842d38a1.svg";
export { ForwardRef as ReactComponent };